import { useUser } from '@auth0/nextjs-auth0'
import { isNil } from 'lodash'
import { useQueryState } from 'nuqs'

export type UserContext = ReturnType<typeof useUser>

type UseMe = UserContext & {
    isGod: boolean
    companyId: string
    setCompanyId: (companyId: string | null) => void
}

const DEFAULT_COMPANY_ID = 'me'

export const useMe = (): UseMe => {
    const auth0user = useUser()
    const [companyId, setCompanyId] = useQueryState('company_id')

    const isGod = isNil(auth0user.user?.org_id)

    return {
        ...auth0user,
        isGod,
        companyId: (isGod ? companyId : DEFAULT_COMPANY_ID) ?? DEFAULT_COMPANY_ID,
        setCompanyId: (newCompanyId: string | null) => {
            setCompanyId(newCompanyId ?? DEFAULT_COMPANY_ID)
        }
    }
}
